import type { UserLoginRequestPayload } from '@/redux/auth/types'
import { httpClient } from './httpClient'

interface UserLoginWithCodePayload {
  email: string
}

interface UserLoginWithCodeConfirmPayload {
  token: string
}

export async function login ({
  username,
  password,
  role
}: UserLoginRequestPayload) {
  try {
    const response = await httpClient({
      baseURL:
        role === 'doctor'
          ? import.meta.env.VITE_API_MAIN_BASEURL
          : import.meta.env.VITE_API_PATIENT_BASEURL,
      url: import.meta.env.VITE_LOGIN_ENDPOINT,
      method: 'POST',
      data: { login: username, password }
    })

    return response.data
  } catch (error) {
    console.error('login - Error: ', error)
    throw error
  }
}

export async function loginWithCode ({
  email
}: UserLoginWithCodePayload) {
  try {
    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url: import.meta.env.VITE_LOGIN_WITH_EMAIL_CODE_ENDPOINT,
      method: 'POST',
      data: { email }
    })

    return response.data
  } catch (error) {
    console.error('loginWithCode - Error: ', error)
    throw error
  }
}

export async function loginWithCodeConfirmation ({
  token
}: UserLoginWithCodeConfirmPayload) {
  try {
    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url: import.meta.env.VITE_LOGIN_WITH_EMAIL_CODE_CONFIRM_ENDPOINT,
      method: 'POST',
      data: { token }
    })

    return response
  } catch (error) {
    console.error('loginWithCodeConfirmation - Error: ', error)
    throw error
  }
}
